import ComparisonTable from '@/components/tables/ComparisonTable';
import { Column } from '@/components/tables/ComparisonTable/components';
import { COLORS } from '@/styles/color';
import { mediaBreakpointUp, square } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize, remCalc } from '@/styles/typography/utils';
import styled from 'styled-components';

export const Section = styled.section`
  ${mediaBreakpointUp('desktop')} {
    display: grid;
    grid-template-columns: repeat(18, 1fr);
    column-gap: 20px;

    > * {
      grid-column: 2 / -2;
    }
  }
`;

export const Heading = styled.h2`
  ${customTextSize(32, 38)}
  font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  letter-spacing: -0.01em;
  padding-top: 51px;
  margin-bottom: 40px;
  text-align: center;

  ${mediaBreakpointUp('tablet')} {
    padding-top: 0;
  }

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(49, 58)}
    margin-bottom: 60px;
  }
`;

export const Wrapper = styled.div`
  padding: ${remCalc(27)};

  ${mediaBreakpointUp('tablet')} {
    padding: ${remCalc(40, 28, 60)};
  }

  ${mediaBreakpointUp('desktop')} {
    padding: ${remCalc(60, 50)};
  }

  ${mediaBreakpointUp('desktopWide')} {
    padding: ${remCalc(60)};
  }
`;

export const StyledTable = styled(ComparisonTable)`
  ${Column}[data-first-column] {
    border-color: ${COLORS.GREEN.BASE};
  }

  ${mediaBreakpointUp('tablet')} {
    ${Column} {
      &[data-first-column] {
        border-color: ${COLORS.GREEN.BASE};
        border-right-color: #a4ccc0;
      }
    }
  }
`;

export const TableHeader = styled.div`
  ${customTextSize(14, 20)};

  h4 {
    ${customTextSize(24, 30)};
    font-weight: ${FONT_WEIGHTS.SEMIBOLD};
    letter-spacing: -0.01em;
    margin-bottom: ${remCalc(18)};
  }

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(18, 26)};

    h4 {
      ${customTextSize(38, 46)};
    }
  }
`;

export const Logo = styled.div`
  ${square(48)}
  margin-bottom: ${remCalc(20)};
  display: flex;
  align-items: center;
  justify-content: flex-start;

  > div {
    width: 100%;
  }

  svg {
    max-width: 100%;
    max-height: 100%;
  }

  ${mediaBreakpointUp('tablet')} {
    ${square(65)}
  }
`;
